module.exports = __webpack_public_path__ + "img/ts25.595ba2c4.png";